var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.data),function(productId){return [(
        _vm.prodById(productId).icon !== null && _vm.prodById(productId).name !== null
      )?_c('b-tooltip',{key:productId,attrs:{"label":_vm.prodById(productId).name,"type":"is-gold is-light"}},[_c('b-icon',{class:_vm.dataClass,attrs:{"icon-pack":"fas","icon":_vm.prodById(productId).icon,"size":_vm.dataSize}})],1):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }